import { ROUTER } from 'src/constants';

import { history, encodeQuery, fireToast, t } from 'utils';

import { VirtualDistance } from '../types';

function onNavigateToSegments(distance: VirtualDistance) {
  return () => {
    const distanceId = distance.id;
    const racerId = distance.racers[0].id;

    if (!distance.published) {
      fireToast(t.staticAsString('toast.message.unpublishedRace'), 'warning', t.staticAsString('toast.title.unpublishedRace'), 'top-right');
      return;
    }

    history.push(
      encodeQuery.generatePath(
        ROUTER.SEGMENTS,
        {},
        {
          distance_id: distanceId,
          racer_id: racerId,
        },
      ),
    );
  };
}

export { onNavigateToSegments };
